<template>
    <div class="notifications">
        <button class="opener" @click="isOpen = !isOpen; $store.state.hasNotifications = false;">
            <icon-bell></icon-bell>
            <div class="pallino" v-if="$store.state.hasNotifications"></div>
        </button>
        <div class="drawerBg" v-if="isOpen" @click="isOpen = false">
            <div class="drawer" @scroll="checkEnd" @click.stop>
                <div v-if="list.length == 0">
                    <div class="notificationRow">
                        <localized-text localizedKey="Nessuna notifica ricevuta" text="Nessuna notifica ricevuta"></localized-text>
                    </div>
                </div>
                <div v-for="item in list" :key="item.identifier">
                    <backendNotificationNewChatMessage @close="onClose(item)" :item="item" v-if="item.type == 'BackendNotificationNewChatMessage'"></backendNotificationNewChatMessage>
                    <backendNotificationVillageTripBooked @close="onClose(item)" :item="item" v-if="item.type == 'BackendNotificationVillageTripBooked'"></backendNotificationVillageTripBooked>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { BackendNotificationClient } from '@/services/Services';
import store from '@/store';
import backendNotificationNewChatMessage from './backendNotificationNewChatMessage.vue'
import backendNotificationVillageTripBooked from './backendNotificationVillageTripBooked.vue'

@Options({
    components: {
        backendNotificationNewChatMessage,
        backendNotificationVillageTripBooked
    }
})
export default class backendNotifications extends Vue {

    isOpen: boolean = false;

    list: OM.BaseBackendNotification[] = [];
    loading: boolean = false;
    finished: boolean = false;

    created(){
        this.init();
        store.state.onBackendNotificationCbs.push(this.onBackendNotification);
    }

    onBackendNotification(notification: OM.BaseBackendNotification){
        this.list.unshift(notification);
    }

    beforeUnmount(){
        let index = store.state.onBackendNotificationCbs.indexOf(this.onBackendNotification);
        store.state.onBackendNotificationCbs.splice(index, 1);
    }

    init(){
        if(this.loading || this.finished)
            return;
        
        this.loading = true;

        BackendNotificationClient.getByUser(store.state.user.identifier, false, this.list.length)
        .then(x => {
            if(x.length == 0){
                this.finished = true;
            }
            this.list.push(...x);
            this.loading = false;
        })
    }

    checkEnd(ev: any){
        if(ev.target.scrollHeight - ev.target.scrollTop - ev.target.clientHeight < 10){
            this.init();
        }
    }

    onClose(item: OM.BaseBackendNotification){
        item.readOn = new Date().toISOString();
        this.isOpen = false;
    }

}

</script>
